module.exports = __webpack_public_path__ + "static/img/empty-learning.dc85ff0c.png";